import { render, staticRenderFns } from "./MeuPainelAprovacoesSolicitacoes.vue?vue&type=template&id=0cd7820a&scoped=true&"
import script from "./MeuPainelAprovacoesSolicitacoes.vue?vue&type=script&lang=js&"
export * from "./MeuPainelAprovacoesSolicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./MeuPainelAprovacoesSolicitacoes.vue?vue&type=style&index=0&id=0cd7820a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd7820a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VDivider,VList,VListItem,VListItemContent,VRow})
